// @flow
import * as React from 'react'
import SVGResponsive, { type PublicProps } from 'icon/SVGResponsive'

type Props = PublicProps & {
  strokeColor: string,
}

export default class HamburgerMenuIcon extends React.Component<Props> {
  static defaultProps = {
    title: 'See Menu',
  }

  render = () => {
    const { strokeColor, ...rest } = this.props

    return (
      <SVGResponsive {...rest} width={22} height={20}>
        <g fill="none" fillRule="evenodd">
          <g stroke={strokeColor} strokeLinecap="square" strokeWidth="2">
            <path d="M1.435 10h19.15M1.435 17h19.15M1.435 3h19.15" />
          </g>
        </g>
      </SVGResponsive>
    )
  }
}
